import Styles from './LinkedinLoadingPreview.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const LinkedinLoadingPreview = () => {
  return (
    <div className={Styles.linkedinLoadingPreview}>
      <div className={Styles.header}>
        <Skeleton avatar={{ size: 48 }} active paragraph={{ rows: 3, width: 69 }} title={false} />
      </div>
      <div className={Styles.text}>
        <Skeleton
          active
          className={Styles.title}
          paragraph={{ rows: 3, width: 69, className: Styles.title }}
          title={false}
        />
      </div>
      <div className={Styles.body}></div>
      <div className={Styles.footer}>
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: '90%' }} title={false} />
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: '90%' }} title={false} />
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: '90%' }} title={false} />
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: '90%' }} title={false} />
      </div>
    </div>
  )
}
